import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ComingSoonModal from '../components/common/ComingSoonModal';

const ComingSoonContext = createContext({ open: () => {} });

export const ComingSoonProvider = ({ children }) => {
  const [label, setLabel] = useState(null);

  const open = useCallback((featureLabel) => setLabel(featureLabel || 'This feature'), []);
  const close = useCallback(() => setLabel(null), []);
  const value = useMemo(() => ({ open }), [open]);

  return (
    <ComingSoonContext.Provider value={value}>
      {children}
      {label !== null && <ComingSoonModal label={label} onClose={close} />}
    </ComingSoonContext.Provider>
  );
};

export const useComingSoon = () => useContext(ComingSoonContext);

export default ComingSoonContext;
